import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm.js';

import '@fancyapps/ui/dist/fancybox/fancybox.css';

Fancybox.bind('[data-fancybox]', {
    Toolbar: {
        display: {
            left: [],
            middle: ['infobar'],
            right: ['thumbs', 'close'],
        },
    },
    Carousel: {
        transition: 'slide'
    },
    Images: {
        zoom: false,
        Panzoom: {
            zoom: false,
        },
    }
});
